import { useSelector } from 'react-redux'
import { selectIsCspAuthenticatedFromState } from 'src/redux/selectors/auth.selectors'
import { selectLocationFromState } from 'src/redux/selectors/router.selectors'
import {
  selectBrandId,
  selectEnvConfigFromState,
  selectPrimaryDomain,
} from 'src/redux/selectors/session.selectors'

/**
 * Returns all of the base headers you would need to make an
 * unauthenticated API call to the extend API
 */
export const useGetBaseRequestHeaders = () => {
  // TODO: Refactors all of these values into top level providers
  const envConfig = useSelector(selectEnvConfigFromState)
  const cspAuthenticated = useSelector(selectIsCspAuthenticatedFromState)
  const brandId = useSelector(selectBrandId)
  const primaryDomain = useSelector(selectPrimaryDomain)
  const locationFromState = useSelector(selectLocationFromState)

  return {
    headers: {
      'X-Extend-Brand': brandId,
      'X-Extend-App-ID': primaryDomain,
      'X-Extend-Platform':
        cspAuthenticated || locationFromState.pathname.includes('/csp/')
          ? 'mira'
          : 'web',
      'X-Extend-Platform-Version': navigator?.userAgent || '',
      Accept: 'application/vnd.paywithextend.v2021-03-12+json',
      'Content-Type': 'application/json',
    },
    baseURL: envConfig.API_HOST || 'https://api-stage.paywithextend.com',
  }
}
